import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import Column from "../../components/MainMenuDropdown/components/Column";
import MainMenuLink from "../../components/MainMenuDropdown/components/MainMenuLink";
import MainMenuDropdown from "../../components/MainMenuDropdown";

import { useStore } from "../../../../connect";

import s from "./AnalyticsDropdown.module.scss";

const AnalyticsDropdown = ({ isMobile }) => {
  const { abTest } = useStore();

  return (
    <MainMenuDropdown isMobile={isMobile} classNames={s["analytics-dropdown"]}>
      <Column className={s["analytics-dropdown__column"]}>
        <MainMenuLink
          name={`average-rates__${abTest.analyticsHeaderVariant}`}
        />
        <MainMenuLink
          name={`cargomap__${abTest.analyticsHeaderVariant}`}
        />
        <MainMenuLink
          name={`profitdirections__${abTest.analyticsHeaderVariant}`}
        />
        <MainMenuLink
          name={`index__${abTest.analyticsHeaderVariant}`}
        />
      </Column>
    </MainMenuDropdown>
  );
};

AnalyticsDropdown.propTypes = {
  isMobile: PropTypes.bool,
};

export default observer(AnalyticsDropdown);
